import types from "./orders.types"
import { store, Provider } from "./orders.provider"

const OrderesProvider = Provider, OrdersStore = store, OrdersTypes = types

export { OrderesProvider, OrdersStore, OrdersTypes }